import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import FormDemonstrativos from "../FormDemonstrativos";
import useMontarLogica from "../hooks/useMontarLogica";
import constants from "../../../Constants";

const columns = [
  {
    name: "Nº Nota Fiscal",
    selector: (row) => row.nuItem,
    maxWidth: "5%",
  },
  {
    name: "Data de Emissão",
    selector: (row) => row.dtEmissao,
    maxWidth: "7%",
    cell: (row) => <DateTime value={row.dtEmissao} stringFormat="dd/MM/yyyy" />,
  },
  {
    name: "Data de Vencimento",
    selector: (row) => row.dtVencimento,
    maxWidth: "7%",
    cell: (row) => <DateTime value={row.dtVencimento} stringFormat="dd/MM/yyyy" />,
  },
  {
    name: "Chave",
    selector: (row) => row.txChave,
    maxWidth: "20%",
  },

  {
    name: "CNPJ/CPF Destinatário",
    selector: (row) => row.nuCnpjRemet,
    maxWidth: "10%",
  },
  {
    name: "UF Destino",
    selector: (row) => row.sgUf,
    maxWidth: "5%",
  },
  {
    name: "CFOP",
    selector: (row) => row.codigoFiscalOperacao,
    maxWidth: "5%",
  },
  {
    name: "Valor Nota",
    cell: (row) =>
      row.valorTotalNota ? row.valorTotalNota.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "",
    maxWidth: "7%",
  },
  {
    name: "% Agregado",
    selector: (row) => row.porcentagemAgregado,
    maxWidth: "5%",
  },
  {
    name: "Base Calculo Redução",
    cell: (row) =>
      row.valorBaseCalculoReducao
        ? row.valorBaseCalculoReducao.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : "",
    maxWidth: "7%",
  },
  {
    name: "% Base Calculo Redução",
    selector: (row) => row.porcentagemBaseCalculoReducao,
    maxWidth: "5%",
  },
  {
    name: "ICMS a Recolher",
    scell: (row) => (row.vlIcms ? row.vlIcms.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : ""),
    maxWidth: "7%",
  },

  {
    name: "Multa",
    cell: (row) =>
      row.vlMultaOcorrenciaAtual
        ? row.vlMultaOcorrenciaAtual.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : "",
    maxWidth: "7%",
  },
];

const conditionalRowStyles = [
  {
    when: (row) => row.dsItem === "Total",
    style: { backgroundColor: "#d3d3d3", cursor: "not-allowed" },
  },
];

const ListagemU = ({ history, sqItemOcorrencia, sqAcaoFiscal }) => {
  const [reload, setReload] = useState(false); // Estado para forçar a atualização
  const { dataWithTotal, totalRows, isLoading } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia,
    reload,
  });

  const [dados, setDados] = useState({});

  const { montarLogica, mostrarLista, setMostrarLista } = useMontarLogica();

  useEffect(() => {
    if (mostrarLista) {
      montarLogica(1);
    }
  }, [montarLogica, mostrarLista, reload]);

  const voltarListagem = () => {
    setMostrarLista(true);
    setReload((prev) => prev + 1);
  };

  return mostrarLista ? (
    <DataTable
      noHeader
      keyField="sqItemOcorrencia"
      columns={columns}
      data={dataWithTotal}
      progressPending={isLoading}
      noDataComponent="Nenhum registro para exibir"
      progressComponent={<TextSpinner />}
      paginationTotalRows={totalRows}
      pointerOnHover
      pagination
      paginationComponentOptions={constants.paginationComponentOptions}
      paginationRowsPerPageOptions={[10, 20, 50, 100, 1000]}
      onRowClicked={(row) => {
        if (row.nuItem !== "Total") {
          setDados(row);
          montarLogica(4);
        }
      }}
      conditionalRowStyles={conditionalRowStyles}
      paginationPerPage={10}
      selectableRowDisabled={(row) => row.nuItem === "Total"}
      selectableRowsVisibleOnly={(row) => !(row.nuItem === "Total")}
    />
  ) : (
    <FormDemonstrativos
      tipoDetalhamento={dados.tipoDetalhamento}
      sqItemOcorrencia={dados.sqItemOcorrencia}
      sqAcaoFiscal={dados.sqAcaoFiscal}
      dadosOcorrencia={dados}
      history={history}
      voltarListagem={() => voltarListagem()}
    />
  );
};

export default ListagemU;
